import React from 'react';

export interface Props {
    viewportHeightDiff?: number | null;
    children: React.ReactNode;
}

export default class OnsiteNotificationsScrollable extends React.Component<Props> {
    innerHeight: number | string = 'auto';
    scrollableNode = React.createRef<HTMLDivElement>();

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (
            nextProps.viewportHeightDiff != null &&
            nextProps.viewportHeightDiff !== this.props.viewportHeightDiff
        ) {
            this.setInnerHeight(nextProps.viewportHeightDiff);
        }
    }

    handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
        const node = this.scrollableNode.current;

        if (!node) return;

        const scrollHeight = node.scrollHeight;
        const scrollTop = node.scrollTop;
        const clientHeight = node.clientHeight;
        const isDeltaPositive = e.deltaY > 0;

        if (
            this.isScrollingPreventable(scrollHeight, clientHeight) &&
            (this.isScrollingAtTop(isDeltaPositive, scrollTop) ||
                this.isScrollingAtBottom(isDeltaPositive, scrollTop, scrollHeight, clientHeight))
        ) {
            e.preventDefault();
        }
    };

    isScrollingPreventable(scrollHeight: number, clientHeight: number) {
        // allow scrollable prevention when scrollable panel is large enough to have internal scrolling
        return scrollHeight > clientHeight;
    }

    isScrollingAtTop(isDeltaPositive: boolean, scrollTop: number) {
        return !isDeltaPositive && scrollTop === 0;
    }

    isScrollingAtBottom(
        isDeltaPositive: boolean,
        scrollTop: number,
        scrollHeight: number,
        clientHeight: number
    ) {
        return isDeltaPositive && scrollTop >= scrollHeight - clientHeight;
    }

    setInnerHeight(viewportHeightDiff: number) {
        if (this.scrollableNode.current) {
            const height = this.scrollableNode.current.offsetHeight + viewportHeightDiff;
            this.innerHeight = height > 0 ? height : 'auto';
        }
    }

    getStyles() {
        return { height: this.innerHeight };
    }

    render() {
        return (
            <div className="onsite-notifications__content-scroll">
                <div
                    ref={this.scrollableNode}
                    onWheel={this.handleWheel}
                    className="onsite-notifications__content-scroll__inner"
                    style={this.getStyles()}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}
